import type { ReactNode } from 'react';
import { Card } from '@/components/ui/Card';
import { cn } from '@/utils/cn';
import type { DashboardThemeId } from '@/pages/dashboard/dashboardThemes';

interface DashboardWidgetFrameProps {
  theme?: DashboardThemeId;
  className?: string;
  children: ReactNode;
}

/**
 * V2 card surface for every dashboard widget (`--card` in both themes).
 * Theme is accepted so stored customize-mode callers keep compiling;
 * pastel fills are no longer applied.
 */
export function DashboardWidgetFrame({ className, children }: DashboardWidgetFrameProps) {
  return (
    <Card className={cn('flex h-full min-h-0 flex-col overflow-hidden', className)}>
      {children}
    </Card>
  );
}
